var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comprehensive_Emblem",
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 92,
    fill: "none",
    stroke: "#0099CC",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 88,
    fill: "none",
    stroke: "#D32F2F",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "textCirclePath",
    d: "M -72,0 A 72,72 0 1,1 72,0"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 900,
    fill: "#D32F2F",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#textCirclePath",
    startOffset: "50%",
    textAnchor: "middle"
  }, "\n        Randeva Advisory Services Pvt Ltd.\n      ")), /*#__PURE__*/React.createElement("circle", {
    r: 60,
    fill: "#F2E6C4",
    stroke: "#D32F2F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -46,
    y: 15,
    fontFamily: "Georgia, serif",
    fontSize: 48,
    fontStyle: "italic",
    fontWeight: "bold",
    fill: "#D32F2F",
    filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.2))"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: -16,
    y: 15,
    fontFamily: "Georgia, serif",
    fontSize: 48,
    fontStyle: "italic",
    fontWeight: "bold",
    fill: "#0099CC",
    filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.2))"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 15,
    fontFamily: "Georgia, serif",
    fontSize: 48,
    fontStyle: "italic",
    fontWeight: "bold",
    fill: "#333333",
    filter: "drop-shadow(1px 1px 1px rgba(0,0,0,0.2))"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: -35,
    y: 75,
    fontSize: 20,
    fill: "#2E7D32",
    textAnchor: "middle"
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 82,
    fontSize: 26,
    fill: "#D32F2F",
    textAnchor: "middle"
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 75,
    fontSize: 20,
    fill: "#2E7D32",
    textAnchor: "middle"
  }, "\u2605"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.a72f672ab7998657219b04a79b40bfa9.svg";
export { ForwardRef as ReactComponent };